<div class="login-screen">
  <div class="login-brand-panel">
    <div class="brand-panel-glow"></div>
    <div class="brand-panel-content">
      <img src="/assets/logo.png" alt="Fork & Find" class="brand-logo" />
      <div class="brand-illustration">
        <i class="bx bx-restaurant"></i>
      </div>
      <h1 class="brand-heading">One platform, every restaurant</h1>
      <p class="brand-subheading">
        Search for a restaurant to jump straight into its menu, orders, staff, and more.
      </p>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="signup-widget">
      <div class="logo">
        <img src="/assets/logo.png" alt="Company Logo" height="32" width="107" />
      </div>
      <div class="main">
        <div class="login-body">
          <div class="login-heading">
            <h2>Find a restaurant</h2>
            <p>
              Choose the restaurant you'd like to access. Once selected, you'll be able to manage
              menus, orders, staff, tables, and all other restaurant operations.
            </p>
          </div>

          <div class="search-field">
            <i class="bx bx-search input-icon"></i>
            <input
              type="text"
              id="browser"
              [(ngModel)]="selectedRestaurant"
              (input)="filterOptions()"
              (focus)="showDropdown = true"
              (blur)="hideDropdown()"
              autocomplete="off"
              placeholder="Enter restaurant name"
              class="form-control"
            />
            @if (showDropdown) {
              <div class="dropdown-list">
                @if (filteredRestaurants.length > 0) {
                  @for (option of filteredRestaurants; track option; let i = $index) {
                    <div (mousedown)="selectOption(option)" class="dropdown-item">
                      <span class="dropdown-item-avatar">{{
                        option.restaurant_name.charAt(0)
                      }}</span>
                      <span class="dropdown-item-text">
                        <span class="dropdown-item-name">{{ option.restaurant_name }}</span>
                        <span class="dropdown-item-address">{{ option.address }}</span>
                      </span>
                    </div>
                  }
                } @else {
                  <div class="dropdown-empty">
                    <i class="bx bx-search-alt"></i>
                    No restaurants match "{{ selectedRestaurant }}".
                  </div>
                }
              </div>
            }
          </div>

          <button class="btn-login" (click)="onSubmit()" [disabled]="selectedRestaurant == null">
            Continue with Restaurant
            <i class="bx bx-right-arrow-alt"></i>
          </button>

          @if (errorMessage != '') {
            <div class="error">
              <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
              <p class="pt-2 pl-2">{{ errorMessage }}</p>
            </div>
          }
        </div>
      </div>
      <div class="policy">
        <p>Copyright © {{ currentYear }} Fork & Find. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</div>
